'use client';
import classNames from 'classnames';
import { ChangeEvent, FC, useActionState, useEffect, useState } from 'react';

import { useSession } from '@/entities/user';
import { loginAction } from '@/features/auth';
import { Input } from '@/shared/ui';
import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import { useModalStore } from '@/widgets/modals/model/store';

import styles from './signIn.module.scss';

interface SignInProps {
  className?: string;
}

const initialState = {
  message: '',
  success: false,
  fieldErrors: { email: '', password: '' },
  data: null,
};

const SignIn: FC<SignInProps> = (props) => {
  const { className } = props;
  const { openModal, closeModal } = useModalStore();
  const [state, formAction, isPending] = useActionState(
    loginAction,
    initialState,
  );
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const { refetch } = useSession(false);

  useEffect(() => {
    if (state.success && state.data) {
      refetch();
      closeModal();
    }
  }, [state, closeModal, refetch]);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.container__content}>
        <div className={styles.container__titleBlock}>
          <p className={styles.container__title}>Вход</p>
        </div>
        <form action={formAction} className={styles.container__form}>
          <div className={styles.container__form_item}>
            <Input
              className={styles.container__form_input}
              error={state?.fieldErrors?.email}
              label="E-mail"
              name="email"
              value={form.email}
              onChange={handleInputChange}
            />
            <Input
              buttonType="button"
              className={styles.container__form_input}
              error={state?.fieldErrors?.password}
              label="Пароль"
              name="password"
              rightIcon={showPassword ? 'eyeOpen' : 'eyeClosed'}
              type={showPassword ? 'text' : 'password'}
              value={form.password}
              onButtonClick={toggleShowPassword}
              onChange={handleInputChange}
            />
          </div>
          {state.message && <p role="alert">{state.message}</p>}
          <button
            className={classNames('button button--confirm-white')}
            disabled={isPending}
            type="submit"
          >
            Войти
          </button>
        </form>
        <button
          className={classNames(
            'link link--underline',
            styles.container__forgot_link,
          )}
          onClick={() => openModal(MODAL_TYPES.forgotPassword)}
        >
          Забыли пароль?
        </button>
      </div>
      <div className={styles.container__bottom}>
        <button
          className={classNames('button button--confirm-black')}
          onClick={() => openModal(MODAL_TYPES.signUp)}
        >
          Зарегистрироваться
        </button>
      </div>
    </div>
  );
};

export default SignIn;
